export default __webpack_public_path__ + "static/media/rice02.276e68a4.png";